// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.KS23bgOmeqAHiS1GRLHD{box-shadow:inset 0 0 0 1px var(--border-neutral-default);border-radius:6px;flex-direction:column;gap:24px;display:flex}.KS23bgOmeqAHiS1GRLHD.KuFwomd7EJwHgj0GlO2J{padding:4px}.KS23bgOmeqAHiS1GRLHD.KuFwomd7EJwHgj0GlO2J .e36CCmTaia8saIm4piW4{gap:12px;padding:8px}.KS23bgOmeqAHiS1GRLHD.HeaQ651tsM6tKpwERpoT{padding:24px}.KS23bgOmeqAHiS1GRLHD.HeaQ651tsM6tKpwERpoT .JNVPCCNpXUPPb3V24yGU{min-height:24px}.VNi8VxO8jswkSspuw6e1{flex-direction:column;gap:4px;display:flex}.JNVPCCNpXUPPb3V24yGU{align-items:center;display:flex}.HRrnKUNnaI4IhtvnJaSm{flex:1 0 0;align-items:center;gap:4px;display:flex}.e36CCmTaia8saIm4piW4{flex-direction:row;justify-content:space-between;align-items:flex-start;display:flex}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `KS23bgOmeqAHiS1GRLHD`,
	"sizesmall": `KuFwomd7EJwHgj0GlO2J`,
	"content": `e36CCmTaia8saIm4piW4`,
	"sizemedium": `HeaQ651tsM6tKpwERpoT`,
	"rightContent": `JNVPCCNpXUPPb3V24yGU`,
	"left": `VNi8VxO8jswkSspuw6e1`,
	"row": `HRrnKUNnaI4IhtvnJaSm`
};
export default ___CSS_LOADER_EXPORT___;
